//@ts-strict-ignore
import React from 'react';
import { ImportedAmazonOrder } from '../../graphql/entities';
import Workspace from '../../components/Workspace/Workspace';
import Formatters from '../../components/grid-addons/formatters';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { IWorkspaceColumnOverride } from '../../@types/workspaceTypes';
import { Direction, IImportedAmazonOrder } from '../../graphql/schema/p4types';
import { useImportedOrderWorkspaceActions } from '../../actions/sales/ImportedOrderWorkspaceAction';
import ImportAmazonOrderRetryMutation from '../../graphql/mutations/sales/ImportAmazonOrderRetryMutation.graphql';
import { WorkspaceActionButtons } from '../../components/Workspace/WorkspaceActionButtons';
import { Paths } from '../../@types/keyOfNested';
import { DispatchSource } from '../../components/ActionButtons/dispatch/DispatchModal';

const IMPORTED_AMAZON_ORDER_FIELD_NAMES: Array<Paths<IImportedAmazonOrder>> = [
  'createdAt',
  'amazonConfiguration.name',
  'orderReference',
  'salesOrder.orderNumber',
  'orderImportFailureReason',
  'failureDescription',
  'shippedAt',
  'resolved',
];

const IMPORTED_AMAZON_ORDER_COLUMN_OVERRIDES: IWorkspaceColumnOverride = {
  orderImportFailureReason: {
    options: fieldMetaData.OrderImportFailureReason,
    formatter: Formatters.EnumFormatter,
  },
};

const ImportAmazonOrderWorkspaceActions = (props) => {
  const [actions, modals] = useImportedOrderWorkspaceActions({
    retryMutation: ImportAmazonOrderRetryMutation,
    type: 'importedAmazonOrders',
    dispatchSource: DispatchSource.ImportedAmazonOrderWorkspace,
  });

  return (
    <>
      {modals}
      <WorkspaceActionButtons {...props} actionButtons={actions} />
    </>
  );
};

const ImportedAmazonOrderWorkspace = (props) => {
  const workspaceProps = useWorkspace<IImportedAmazonOrder>(props, ImportedAmazonOrder, {
    columns: IMPORTED_AMAZON_ORDER_FIELD_NAMES,
    columnOverrides: IMPORTED_AMAZON_ORDER_COLUMN_OVERRIDES,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={ImportedAmazonOrder.type}
      title={ImportedAmazonOrder.title}
      formUrl={ImportedAmazonOrder.formUrl}
      defaultQuery={ImportedAmazonOrder.workspace}
      entity={ImportedAmazonOrder}
      permittedOperations={ImportedAmazonOrder.operations}
      {...workspaceProps}
      {...props}
      workspaceActionButtonsHOC={ImportAmazonOrderWorkspaceActions}
    />
  );
};

export default ImportedAmazonOrderWorkspace;
